<template>
  <Transition name="overlay" appear>
    <div data-cy="business-switch-overlay"
      v-if="switching"
      class="business-switch-overlay"
      :class="{'customized-affiliate': !!affiliateCustomizations}">
      <span class="text-center fw-bold">
        Switching Businesses<span class="dots-container">{{ animatedDots }}</span>
      </span>
    </div>
  </Transition>
</template>

<script>
import { useBusinessSwitchStore } from '~/store/business-switch';
import { storeToRefs } from 'pinia';
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';

export default {
  name: 'BusinessSwitchOverlay',
  data() {
    return {
      animatedDots: '.',
      dotsInterval: null,
    }
  },
  async setup() {
    const businessSwitchStore = useBusinessSwitchStore();
    const { switching } = storeToRefs(businessSwitchStore);
    return {
      switching,
      affiliateCustomizations: useAffiliateCustomizationStore().affiliateCustomizations,
    }
  },
  watch: {
    switching(newVal) {
      if (newVal) {
        this.startDotsAnimation()
      } else {
        setTimeout(() => {
          this.stopDotsAnimation()
        }, 2000)
      }
    }
  },
  methods: {
    startDotsAnimation() {
      this.animatedDots = '.'
      let dotCount = 1
      this.dotsInterval = setInterval(() => {
        dotCount = dotCount >= 3 ? 1 : dotCount + 1
        this.animatedDots = '.'.repeat(dotCount)
      }, 500)
    },
    stopDotsAnimation() {
      if (this.dotsInterval) {
        clearInterval(this.dotsInterval)
        this.dotsInterval = null
      }
      this.animatedDots = '.'
    },
  },
  beforeUnmount() {
    this.stopDotsAnimation()
  },
}
</script>

<style lang="scss" scoped>
.business-switch-overlay {
  font-size: 24px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-enter-active {
  transition: opacity 0.5s ease, backdrop-filter 0.5s ease;
}

.overlay-leave-active {
  transition: opacity 0.75s ease, backdrop-filter 0.75s ease;
}

.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);
}

.dots-container {
  display: inline-block;
  width: 1.5em;
  text-align: left;
}
</style>
